// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"lp-z","breadcrumbForward":"mp-z","breadcrumbBack":"np-z","selected":"op-z"};